const getSearchUrl = function getSearchUrl(url, query) {
  let searchUrl;
  const hasParams = url.match(/\?\w+=\w+/);
  const encodedQuery = encodeURIComponent(query);

  if (hasParams) {
    searchUrl = `${url}&q=${encodedQuery}`;
  } else {
    searchUrl = `${url}?q=${encodedQuery}`;
  }

  return searchUrl;
};

export default getSearchUrl;
